import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/App.css';
import './fonts/san-fransisco-font.css';
import reportWebVitals from './reportWebVitals';
import './translations/i18n';
import './css/index.css';
import ReactGA from 'react-ga4';
import PublicApp from './PublicApp';
import {BrowserRouter} from 'react-router-dom';

const TRACKING_ID = 'G-6R82RM8CRH';

ReactGA.initialize(TRACKING_ID);

window.addEventListener('error', function (event) {
	console.error('Uncaught error:', event.error);
});

window.addEventListener('unhandledrejection', function (event) {
	console.error('Unhandled promise rejection:', event.reason);
});

// Create a custom tracker component to track page views
function RouteTracker() {
	React.useEffect(() => {
		// Send pageview with the current location.pathname
		ReactGA.send({hitType: 'pageview', page: window.location.pathname});
	}, []);

	return null;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<RouteTracker />
			<PublicApp />
		</BrowserRouter>
	</React.StrictMode>
);

reportWebVitals();
